// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Z6yuS","main-image":"Header_main-image__10RoN"};